import { useState, useEffect, useContext } from "preact/hooks";
import { createContext } from "preact/compat";

import useMenu from "@/hooks/useMenu";
import { useLocation } from "react-router-dom";
import useLocalStorageState from "use-local-storage-state";

const MenuContext = createContext();
export const BrandContext = createContext();

export function BrandProvider({ children }) {
	const [retailerObject, setRetailerObject] = useLocalStorageState("dutchie_retailer");
	const retailerId = retailerObject?.id;

	const [brandID, setBrandID] = useState(window.dutchie_brand?.retailers[retailerId]);
	const [brand, setBrand] = useState(window.dutchie_brand);

    useEffect(() => {
        if ( retailerId ) {
            setBrandID(window.dutchie_brand?.retailers[retailerId]);
            setBrand(window.dutchie_brand);
        }
    }, [retailerId]);

	const value = { 
		brandID, 
		setBrandID,
		brand,
		setBrand
	};

	return <BrandContext.Provider value={value}>{children}</BrandContext.Provider>;
}

export function MenuProvider({ children, categorySlug, subCategorySlug, specialID, special, specialItems = false }) {
	const location = useLocation();
  	const { brandID, setBrandID, brand, setBrand } = useContext(BrandContext);

	useEffect(() => {
		if ( location.state?.brandID ) {
			setBrandID(location.state.brandID);
		}
		
		if ( location.state?.brand ) {
			setBrand(location.state.brand);
		}
	}, [location]); // runs when location changes

    const menu = useMenu(categorySlug, subCategorySlug, brandID, specialID, special, specialItems);
    return <MenuContext.Provider value={menu}>{children}</MenuContext.Provider>;
}

export default MenuContext;